import React, { Component } from 'react';
import "./cookie_banner.scss";
import CookieConsent from "react-cookie-consent";


class CookieBanner extends Component {

    render() {
        return (
            <>
                <div id={'cookie-banner'}>
                    {/* <CookieConsent
                        debug={false} // if debug is true, cookie are reloaded - development function
                        location="bottom"
                        buttonText="&#215;"  // Accept button is X
                        cookieName="CookieBannerLuiss"
                        contentClasses="main-wrap-cookie"
                        style={{ background: "rgba(255, 255, 255, 0.95)",
                                 color:'#000',
                                 fontSize: "14px",
                                 minHeight:"66px",
                                 margin:"0"
                               }}
                        buttonClasses="btn-accept"
                        buttonStyle={{ background: "transparent",
                                       color: "#000",
                                       fontSize: "40px",
                                       height:"66px",
                                       margin: '0',
                                       marginRight:'32px',
                                       alignSelf: 'center'
                                     }}
                        expires={365} // days
                        acceptOnScroll={true}
                    >
                    <p style={{margin: "0"}}>
                        Al fine di migliorare la tua esperienza di navigazione, questo sito utilizza i cookie di profilazione di terze parti. Chiudendo questo banner o accedendo ad un qualunque elemento
                        sottostante acconsenti all’uso dei cookie. Se vuoi saperne di più o negare il consenso a tutti o solo ad alcuni cookie, <a href={"/informativa-sulla-privacy"}>leggi la cookie policy.</a>
                    </p>
                    </CookieConsent> */}
                </div>
            </>
        )
    }

}


export default CookieBanner;

